import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
